import { Notification } from '@innovationnorway/component-library';
import { apiClient } from '../../lib/query/apiClient';

// Renders the markdown subset allowed in service messages (**bold** and line breaks), see docs/service-messages.md.
// If we need more formatting, or support Markdown, we can use a library like react-markdown, but for now this is enough.
const MessageBody = ({ text }: { text: string }) => (
  <>
    {text.split('\n').map((line, i) => (
      <p key={i}>{line.split(/(\*\*[^*]+\*\*)/g).map((part, j) => (part.startsWith('**') && part.endsWith('**') ? <strong key={j}>{part.slice(2, -2)}</strong> : part))}</p>
    ))}
  </>
);

export const ServiceMessageList = () => {
  const { data: serviceMessages } = apiClient.useQuery('get', '/api/v1/ServiceMessages/GetServiceMessages');

  if (!serviceMessages) return null;

  return (
    <div className="service-message-list flex flex-col gap-8 mb-8">
      {serviceMessages?.map((message, index) => (
        <Notification key={index} type={message.type} fullWidth>
          {message.header && <h2>{message.header}</h2>}
          <MessageBody text={message.body ?? ''} />
        </Notification>
      ))}
    </div>
  );
};
